import { PERMISSIONS } from "../../../permissions";

export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-people'
    },
    // {
    //   name: 'Savings Report',
    //   url: '/savingsReport',
    //   icon: 'icon-drawer'
    // },
    {
      name: 'User Access',
      url: '/userAccess',
      icon: 'icon-user',
      permissions: [
        PERMISSIONS.READ_STAFF
      ]
    },
    {
      name: 'Transactions',
      url: '/transactions',
      icon: 'icon-chart',
      permissions: [
        PERMISSIONS.READ_TRANSACTIONS
      ]
    },
    {
      name: 'Investments',
      url: '/deposits',
      icon: 'icon-chart',
      permissions: [
        PERMISSIONS.READ_TRANSACTIONS
      ]
    },
    {
      name: 'Withdraws',
      url: '/withdraws',
      icon: 'icon-chart',
      permissions: [
        PERMISSIONS.READ_TRANSACTIONS
      ]
    },
    {
      name: 'Finlink Accounts',
      url: '/finlinkAccounts',
      icon: 'icon-credit-card',
      permissions: [
        // PERMISSIONS.READ_BANK_TRANSACTIONS
      ]
    },
    {
      name: 'Loan Applications',
      url: '/loanApplications',
      icon: 'icon-wallet',
      permissions: [
        PERMISSIONS.VIEW_LOANS
      ]
    },
    {
      name: 'Bank Balances',
      url: '/bankBalances',
      icon: 'icon-wallet',
      permissions: [
        PERMISSIONS.READ_BANK_TRANSACTIONS
      ]
    },
    {
      name: 'Reconcilliation',
      url: '/reconcilliation',
      icon: 'icon-compass',
      permissions: [
        // PERMISSIONS.READ_TRANSACTIONS
      ]
    },
    {
      name: 'Audit Trail',
      url: '/auditTrail',
      icon: 'icon-chart',
      permissions: [
        PERMISSIONS.READ_AUDIT_TRAIL
      ]
    },
    {
      name: 'Configurations',
      url: '/configurations',
      icon: 'icon-settings',
      permissions: [
        PERMISSIONS.READ_CONFIGURATIONS
      ]
    },
    {
      name: 'Reminders',
      url: '/reminders',
      icon: 'icon-clock',
      permissions: [
        
      ]
    }
  ]
}
